import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

export type CreateUploadUrlV2Body =
  paths['/v2/attachments/upload-url']['post']['requestBody']['content']['application/json'];

export async function createUploadUrlV2({
  mimeType,
}: {
  mimeType: CreateUploadUrlV2Body['mimeType'];
}) {
  const { data } = await fetchClient.POST('/v2/attachments/upload-url', {
    body: {
      mimeType,
    },
  });

  return data;
}
